import { useModalA11y } from '../../hooks/useModalA11y.js';

export default function ConfirmDialog({
    isOpen,
    title,
    message,
    variant = 'default', // 'default' or 'danger'
    confirmText = 'Confirmar',
    cancelText = 'Cancelar',
    isLoading = false,
    onConfirm,
    onCancel
}) {
    const modalA11y = useModalA11y(isOpen, onCancel, 'confirm-dialog-title');

    if (!isOpen) return null;

    const isDanger = variant === 'danger';

    return (
        <div className="fixed inset-0 z-[100] flex items-center justify-center p-4 bg-black/60 backdrop-blur-sm animate-fade-in">
            <div
                {...modalA11y}
                className="bg-surface-container rounded-2xl w-full max-w-md shadow-2xl overflow-hidden border border-outline-variant/20 animate-scale-up p-6 flex flex-col space-y-4 text-on-surface"
            >
                <div className="space-y-2">
                    <h2 id="confirm-dialog-title" className="font-serif text-xl font-bold tracking-tight">
                        {title}
                    </h2>
                    <p id="confirm-dialog-desc" className="text-sm font-light text-on-surface-variant leading-relaxed whitespace-pre-line">
                        {message}
                    </p>
                </div>

                <div className="flex gap-2 justify-end pt-2">
                    <button
                        onClick={onCancel}
                        disabled={isLoading}
                        className="px-4 py-2 text-sm font-medium text-on-surface hover:bg-surface-variant/50 rounded-lg transition-colors disabled:opacity-50"
                    >
                        {cancelText}
                    </button>
                    <button
                        onClick={onConfirm}
                        disabled={isLoading}
                        className={`flex-1 min-h-control px-4 py-2 font-bold rounded-lg transition-colors focus:ring-2 focus:ring-offset-2 ${
                            variant === 'danger'
                                ? 'bg-error text-on-error hover:bg-error/90 focus:ring-error'
                                : 'bg-primary text-on-primary hover:bg-primary/90 focus:ring-primary'
                        } ${isLoading ? 'opacity-70 cursor-not-allowed' : ''}`}
                    >
                        {isLoading ? (
                            <span className="material-symbols-outlined animate-spin text-[18px]">progress_activity</span>
                        ) : (
                            confirmText
                        )}
                    </button>
                </div>
            </div>
        </div>
    );
}
